import React from 'react';
import PropTypes from 'prop-types';
import {Menu} from '../';
import {footerCopyright} from '../../../configs/messages';

const Footer = (props) => {
  const {router, gameConfig: {hasLeaderboard, hasTreasureChest, id: gameId}} = props;
  const isAppDetailsLoaded = Boolean(gameId);
  const currenLocation = router.location.pathname;
  const isGameLocation = currenLocation.indexOf('/game') !== -1;

  const mainFooterNav = [
    {
      text: 'Lobby',
      link: '/lobby',
    },
    {
      text: 'Leaderboard',
      link: '/leaderboard',
      renderInFooter: isGameLocation,
      panelMethod: 'toggleLeaderboard',
      disabled: !hasLeaderboard,
    },
    {
      text: 'Treasure Chest',
      link: '/treasure-chest',
      renderInFooter: isGameLocation,
      panelMethod: 'toggleTreasureChest',
      disabled: !hasTreasureChest,
    },
  ];
  const secondaryFooterNav = [
    {
      text: 'Privacy Policy',
      link: '/privacy',
    },
    {
      text: 'Terms & Conditions',
      link: '/terms',
    },
  ];

  const hasNavMenu = isAppDetailsLoaded && (hasLeaderboard || hasTreasureChest);

  return (
    <footer className="footer">
      {hasNavMenu && <Menu links={mainFooterNav} theme="secondary" delimiter/>}
      <Menu links={secondaryFooterNav} theme="minor"/>
      <p className="footer__copywrite">{footerCopyright}</p>
    </footer>
  );
};

Footer.propTypes = {
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  gameConfig: PropTypes.shape({}).isRequired,
};

export default Footer;
